/* i18n helper (global) */
if(typeof window!=="undefined" && typeof window.TR==="undefined"){window.TR=function(k,v){return (window.GS&&GS.t)?GS.t(k,v):k;};}
var TR=window.TR;
/*! UX Experiments — viewer.
 *  /generate -> ranked experiment proposals from the UX Auditor's findings ; POST /set-status.
 *  Talks through the app's GS.api ({ok,status,data}).
 */
(function () {
  function TT(k){ return (window.GS&&GS.t)?GS.t(k):k; }
  "use strict";
  try { (window.GS_BUILD = window.GS_BUILD || {})["ux-experiments"] = "1.0.0"; } catch (e) {}
  if (window.__bxpWired) return; window.__bxpWired = 1;

  var root = document.querySelector('[data-xp="root"]');
  if (!root) return;
  function q(k) { return root.querySelector('[data-xp="' + k + '"]'); }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function siteParam() { return "site=" + encodeURIComponent((window.GS && GS.site) || ""); }
  function num(n) { return (+n || 0).toLocaleString(); }
  function ready(fn) {
    var done = false; function go() { if (done) return; done = true; fn(); }
    document.addEventListener("gs:ready", go, { once: true });
    var n = 0, t = setInterval(function () { if (window.GS && GS.api && GS.site) { clearInterval(t); go(); } else if (++n > 200) clearInterval(t); }, 30);
    if (window.GS && GS.api && GS.site) go();
  }
  function post(path, body) { return GS.api(path + "?" + siteParam(), { method: "POST", body: JSON.stringify(body || {}) }); }
  var STATUSES = ["proposed", "planned", "running", "done", "dismissed"];
  var STAGES = ["proposed", "planned", "running", "done"];
  var WF = {
    proposed:  { next: TR('uxexpe.g.worth_testing_plan_it_or_set_it_asid'), primary: { label: TR('uxexpe.g.plan_it'), to: "planned" }, second: { label: TR('uxexpe.g.dismiss'), to: "dismissed" } },
    planned:   { next: TR('uxexpe.f3.next_define_control_vs_variant_pic'), primary: { label: TR('uxexpe.g.start_running'), to: "running" }, second: { label: TR('uxexpe.g.dismiss'), to: "dismissed" } },
    running:   { next: TR('uxexpe.f3.live_watching_your_metric_mark_it_'), primary: { label: TR('uxexpe.g.mark_done'), to: "done" }, second: { label: TR('uxexpe.g.abandon'), to: "dismissed" } },
    done:      { next: TR('uxexpe.g.apply_the_winning_change_then_re_run'), primary: null, second: { label: TR('uxexpe.g.reopen'), to: "running" } },
    dismissed: { next: TR('uxexpe.f3.set_aside_restore_it_if_the_signal'), primary: { label: TR('uxexpe.g.restore'), to: "proposed" }, second: null }
  };
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function daysSince(v) { if (!v) return null; var t = Date.parse(String(v).replace(" ", "T") + "Z"); if (isNaN(t)) return null; return Math.max(0, Math.floor((Date.now() - t) / 86400000)); }
  var ALLEXPS = [], curStatus = "";
  var WANT_EXP = null, WANT_DONE = false;

  function load() {
    GS.api("/plugin/ux-experiments/generate?" + siteParam()).then(function (r) {
      var d = (r && r.ok && r.data) || {}, list = q("list"), sum = q("summary"), grade = q("grade"), tabs = q("tabs");
      if (d.auditor === false) { sum.hidden = true; grade.hidden = true; if (tabs) tabs.hidden = true; list.innerHTML = '<div class="xp-empty">' + esc(d.note || TR('uxexpe.p.enable_the_ai_ux_auditor_to_generate')) + "</div>"; return; }
      if (d.ux_grade) { grade.hidden = false; grade.className = "xp-grade g-" + d.ux_grade; grade.textContent = "UX " + d.ux_grade; } else grade.hidden = true;
      ALLEXPS = d.experiments || [];
      if (!ALLEXPS.length) { sum.hidden = true; if (tabs) tabs.hidden = true; list.innerHTML = '<div class="xp-empty">' + esc(d.note || TR('uxexpe.f2.no_ux_issues_to_test_right_now')) + "</div>"; return; }
      sum.hidden = false;
      var s = d.summary || {};
      q("s-total").textContent = num(s.total || 0);
      q("s-qw").textContent = num(s.quick_wins || 0);
      q("s-hi").textContent = num((s.by_impact && s.by_impact.High) || 0);
      renderTabs(); renderList(); focusExp();
    });
  }

  // Deep-link focus: /ux-experiments?exp=<key> (used by the UX Auditor's linked-experiment row)
  // scrolls to and briefly rings that card. Runs once; clears any status filter that would hide it.
  function focusExp() {
    if (WANT_DONE || !WANT_EXP) return;
    if (!ALLEXPS.some(function (e) { return e.exp_key === WANT_EXP; })) { WANT_DONE = true; return; }
    if (curStatus && !ALLEXPS.some(function (e) { return e.status === curStatus && e.exp_key === WANT_EXP; })) { curStatus = ""; renderTabs(); renderList(); }
    var list = q("list");
    var btn = list && list.querySelector('[data-exp="' + WANT_EXP.replace(/["\\]/g, "") + '"]');
    var card = btn && btn.closest(".xp-card");
    WANT_DONE = true;
    if (!card) return;
    card.classList.add("xp-focus");
    try { card.scrollIntoView({ behavior: "smooth", block: "center" }); } catch (e) {}
    setTimeout(function () { card.classList.remove("xp-focus"); }, 2400);
  }

  // A filter bar across the lifecycle with live counts. The per-card workflow (stepper + advance
  // buttons) moves an experiment between states; these tabs let you focus on one stage at a time.
  function statusCounts() { var c = {}; ALLEXPS.forEach(function (e) { c[e.status] = (c[e.status] || 0) + 1; }); return c; }
  function renderTabs() {
    var tabs = q("tabs"); if (!tabs) return; tabs.hidden = false;
    var c = statusCounts();
    var html = '<button type="button" class="xp-tab' + (curStatus === "" ? " on" : "") + '" data-st="">'+TR('uxexpe.g.all')+'<b>' + ALLEXPS.length + "</b></button>";
    STATUSES.forEach(function (st) { html += '<button type="button" class="xp-tab st-' + st + (curStatus === st ? " on" : "") + '" data-st="' + st + '">' + st.charAt(0).toUpperCase() + st.slice(1) + " <b>" + (c[st] || 0) + "</b></button>"; });
    tabs.innerHTML = html;
    Array.prototype.forEach.call(tabs.querySelectorAll(".xp-tab"), function (b) { b.addEventListener("click", function () { curStatus = b.getAttribute("data-st"); renderTabs(); renderList(); }); });
  }
  function renderList() {
    var list = q("list");
    var items = curStatus ? ALLEXPS.filter(function (e) { return e.status === curStatus; }) : ALLEXPS;
    if (!items.length) { list.innerHTML = '<div class="xp-empty">No experiments' + (curStatus ? (" marked \u201c" + curStatus + "\u201d") : "") + " right now.</div>"; return; }
    list.innerHTML = items.map(card).join("");
    Array.prototype.forEach.call(list.querySelectorAll("[data-to]"), function (btn) {
      btn.addEventListener("click", function () {
        post("/plugin/ux-experiments/set-status", { exp_key: btn.getAttribute("data-exp"), status: btn.getAttribute("data-to") }).then(load);
      });
    });
  }

  function pageLine(e) {
    if (e.pages && e.pages.length) {
      return '<div class="xp-pages"><span class="xp-pages-l"><i class="bi bi-geo-alt"></i> Worst on</span>' +
        e.pages.map(function (p) {
          var g = String(p.grade || "?").toUpperCase();
          return '<a class="xp-page g-' + esc(g) + '" href="/ux-auditor" title="' + esc(p.url) + " \u2014 grade " + esc(g) + '"><span class="xp-page-g">' + esc(g) + '</span><span class="xp-page-u">' + esc(p.url) + "</span></a>";
        }).join("") +
        (e.page_count > e.pages.length ? '<span class="xp-page-more">+' + (e.page_count - e.pages.length) + " more</span>" : "") +
        "</div>";
    }
    return '<div class="xp-pages xp-pages-none"><span class="xp-pages-l"><i class="bi bi-geo-alt"></i> Where</span><span class="xp-page-any">Across multiple pages \u2014 no single entry page dominates.</span></div>';
  }
  function card(e, i) {
    var key = esc(e.exp_key), cur = STAGES.indexOf(e.status);
    var steps = STAGES.map(function (s, j) {
      return '<button type="button" class="xp-step' + (j < cur ? " past" : "") + (j === cur ? " on " + s : "") + '" data-exp="' + key + '" data-to="' + s + '"' + (j === cur ? ' aria-current="step"' : "") + ">" + cap(s) + "</button>";
    }).join("");
    var wf = WF[e.status] || WF.proposed, nextTxt = wf.next;
    if (e.status === "running") { var dz = daysSince(e.status_since); if (dz != null) nextTxt = TR('uxexpe.g.live') + dz + " day" + (dz === 1 ? "" : "s") + " — watching your metric. Mark it done when the number moves."; }
    function abtn(o, sec) { return o ? '<button type="button" class="xp-adv' + (sec ? " sec" : "") + '" data-exp="' + key + '" data-to="' + o.to + '">' + esc(o.label) + (sec ? "" : " \u2192") + "</button>" : ""; }
    var inspect = (e.status === "planned" || e.status === "running")
      ? '<a class="xp-inspect" href="/ux-doctor' + (e.pages && e.pages[0] && e.pages[0].url ? "?page=" + encodeURIComponent(e.pages[0].url) : "") + '" title="'+TT('uxe.at.open_this_page_in_ux_doctor')+'"><i class="bi bi-crosshair"></i> Inspect on page</a>'
      : "";
    return '<div class="xp-card ' + (e.status === "done" ? "done" : "") + (e.status === "dismissed" ? " dismissed" : "") + '">' +
      '<div class="xp-card-top"><span class="xp-rank">' + (i + 1) + "</span>" +
      '<span class="xp-title">' + esc(e.title) + "</span>" +
      '<span class="xp-badges">' +
        '<span class="xp-badge impact-' + esc(e.expected_impact) + '">' + esc(e.expected_impact) + " impact</span>" +
        '<span class="xp-badge eff">' + esc(e.effort) + " effort</span>" +
        (e.quick_win ? '<span class="xp-badge qw">'+TT('uxe.js.quick_win')+'</span>' : "") +
      "</span></div>" +
      '<div class="xp-from">'+TT('uxe.js_from_issue')+'<b>' + esc(e.issue_title) + "</b> &middot; " + esc(e.severity) + " severity &middot; " + (e.share || 0) + "% of visitors affected</div>" +
      pageLine(e) +
      '<div class="xp-fields">' +
        '<div class="xp-field full"><div class="xp-flabel">'+TR('uxexpe.g.hypothesis')+'</div><div class="xp-ftext">' + esc(e.hypothesis) + "</div></div>" +
        '<div class="xp-field"><div class="xp-flabel">'+TT('uxe.js.what_to_change')+'</div><div class="xp-ftext">' + esc(e.change) + "</div></div>" +
        '<div class="xp-field"><div class="xp-flabel">'+TT('uxe.js.what_to_measure')+'</div><div class="xp-ftext">' + esc(e.metric) + "</div></div>" +
      "</div>" +
      '<div class="xp-foot">' +
        '<div class="xp-steps" role="group" aria-label="'+TT('uxe.at.experiment_stage')+'">' + steps + "</div>" +
        '<div class="xp-next"><span class="xp-next-txt">' + esc(nextTxt) + "</span>" + abtn(wf.primary, false) + abtn(wf.second, true) + inspect + "</div>" +
        '<span class="xp-score">priority <b>' + (e.priority_score || 0) + "</b></span></div></div>";
  }

  ready(function () {
    try { WANT_EXP = new URLSearchParams(location.search).get("exp"); } catch (e) {}
    var rf = q("refresh"); if (rf) rf.addEventListener("click", load);
    load();
  });
})();
